import PanelGraph from 'app/components/tabs/PanelGraph';
import * as React from 'react';
import { getPeerGroupData, getPerformanceTrendData, IFilter, IPeerGroupTabsProps, IVisualizationState, round } from '../../lib/http';

export class PeerGroupYearOverYear extends React.Component<
  IPeerGroupTabsProps,
  IVisualizationState> {
  state: IVisualizationState = {
    categories: [],
    data: [],
    series: [],
    filters: { assetLevel: -1 },
    title: "",
    loading: false,
    average: [],
  };

  componentDidMount() {
    this.setState({ data: this.props.data }, () =>
      this.loadSeries(this.props.filters)
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.filters.assetLevel !== this.props.filters.assetLevel ||
      prevProps.data.length !== this.props.data.length
    ) {
      this.setState(
        { filters: this.props.filters, data: this.props.data },
        () => {
          this.loadSeries(this.props.filters);
        }
      );
    }
  }

  mapFilterIdToColumn(filterId) {
    if (filterId === 0) return '';
    if (filterId === 2) return 'fiveHundred';
    if (filterId === 3) return 'fifty';
    if (filterId === 4) return 'five';
    if (filterId === 5) return 'twenty';
    if (filterId === 6) return 'two';
    if (filterId === 7) return 'oneHundred';
    if (filterId === 8) return 'ten';
    if (filterId === 9) return 'one';
  }

  loadSeries(filters: IFilter) {
    const performanceRequestTab = {
      action: "getAnnualPeerGroupData",
      request: { assetLevel: this.props.filters.assetLevel },
    };
    const column = this.mapFilterIdToColumn(filters.assetLevel)
    getPeerGroupData(performanceRequestTab).then((response: any[]) => {

      const categories = response.map(dataPoint => dataPoint['date'])
      const giv = response.map(dataPoint => parseFloat(round(dataPoint['giv'], 1)))
      let index = []
      if (filters.assetLevel !== 0) {
        index = response.map(dataPoint => parseFloat(round(dataPoint[column], 1)))
      }

      const series = [{ name: 'GIV Index', data: giv, color: '#8EA9DB' }]

      if (filters.assetLevel !== 0) {
        series.push({
          name: filters.assetName + ' Index',
          data: index,
          color: '#B4C6E7',
        })
      }

      this.setState({ series, categories });
    });
  }

  static getChartConfig(series, categories, title) {
    return {
      chart: { type: "column" },
      title: {
        text: title,
      },
      yAxis: {
        visible: true,
        labels: {
          format: "{value}%"
        },
        title: {
          text: ''
        },
      },
      tooltip: {
        pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}%</b><br/>'
      },
      xAxis: { categories },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      series,
    }
  }

  render() {
    const { title, loading, series, categories } = this.state
    return (
      <PanelGraph title="" loading={loading} chartConfig={PeerGroupYearOverYear.getChartConfig(series, categories, title)} />
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/Performance/PeerGroupYearOverYear/index.tsx